import React from 'react';
import CartonMaterialsSection from 'components/quote_builder_widget/CartonMaterialsSection';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const CartonMaterialsSectionWrapper = ({
  showCartonMaterials,
  setShowCartonMaterials,
  onMaterialsChange,
}) => {
  return (
    <div>
      <h4 className={styles.sectionHeader}>
        {t('quote_builder_widget.section_carton_materials')}
      </h4>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>
          {t('quote_builder_widget.carton_materials_enable_disable') || 'Enable / Disable'}
        </label>
        <p className={styles.helpText}>
          {t('quote_builder_widget.carton_materials_info') || 'Materials available in the widget for carton drawings'}
        </p>

        <div className={showCartonMaterials ? styles.toggleContainerEnabled : styles.toggleContainer}>
          <label className={styles.toggleLabel}>
            <input
              type="checkbox"
              checked={showCartonMaterials}
              onChange={(event) => setShowCartonMaterials(event.target.checked)}
              className={styles.toggleCheckbox}
            />
            <span className={styles.toggleText}>
              {showCartonMaterials
                ? (t('quote_builder_widget.carton_materials_enabled') || 'Carton materials are enabled')
                : (t('quote_builder_widget.carton_materials_disabled') || 'Carton materials are disabled')}
            </span>
          </label>
        </div>
      </div>

      {showCartonMaterials && (
        <div className={styles.fieldGroup}>
          <label className={styles.label}>
            {t('quote_builder_widget.carton_unit_prices') || 'Unit Prices'}
          </label>
          <p className={styles.helpText}>
            {t('quote_builder_widget.carton_unit_prices_info') || 'Select which unit prices are available in the widget for carton drawings.'}
          </p>

          <CartonMaterialsSection onMaterialsChange={onMaterialsChange} />
        </div>
      )}
    </div>
  );
};

export default CartonMaterialsSectionWrapper;
